import React, { Component } from 'react'
import './Users.css'

export default class UsersContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            new_timesheet_post: null,
            id_timesheet_user: null,
            Filtered_TeacherList: [],
            searchName: null
        }
    }

    SelectStatusS = (statusS) => {
        this.props.SelectStatusS(statusS)
    }


    onChangeFilterFio = (e) => {
        const { Teacher_List } = this.props

        let searchName = e.target.value
        if (searchName && searchName !== null && searchName !== ' ') {
            let newStr = searchName[0].toUpperCase() + searchName.slice(1)
            let newStrUp = searchName.toUpperCase()
            let newStrLow = searchName.toUpperCase()
            let newStrUpercase = searchName[0].toUpperCase() + searchName.slice(1).toUpperCase()

            const sortTeacher_List = Teacher_List && Teacher_List.length && Teacher_List.filter(item =>
                item.t_fio.includes(newStr) + item.t_fio.includes(newStrUp) + item.t_fio.includes(newStrLow) + item.t_fio.includes(newStrUpercase) + item.t_fio.includes(searchName))

            setTimeout(() => {
                this.setState({ Filtered_TeacherList: sortTeacher_List, searchName });
                this.OpenSelectorOptions(1, 'teacher_list')
            }, 20);
        } else {
            this.OpenSelectorOptions(0, null)
        }
    }

    ChangeTeacher(id_teacher, t_fio) {
        this.props.ChangeTeacher(id_teacher, t_fio)
        if (id_teacher > 0) {
            this.setState({
                searchName: null
            })
        }
    }

    activeUpdateRow(activerow, activerow_ind, id_timesheet_user) {
        // alert(activerow_ind)
        this.setState({ activerow, activerow_ind, id_timesheet_user })
        if (this.props.selected_menu === 3 && activerow === 0) {
            this.props.ChangeKaf_Otdel(null, null)
            this.props.ChangeTeacher(null, null)
            this.props.ChangeDoljnost(null, null)
            this.setState({

            })
        }
        if (this.props.selected_menu === 3 && activerow === 1) {
            const { TimesheetUsers } = this.props
            this.props.ChangeKaf_Otdel(TimesheetUsers[activerow_ind].id_kafedra_otdel, TimesheetUsers[activerow_ind].kafedra_otdel)
            this.props.ChangeTeacher(TimesheetUsers[activerow_ind].id_teacher, TimesheetUsers[activerow_ind].t_fio)
            this.props.ChangeDoljnost(TimesheetUsers[activerow_ind].id_timesheet_post, TimesheetUsers[activerow_ind].timesheet_post)
        }
        this.props.activeUpdateRow(activerow, activerow_ind)
    }
    plusInsertRow(insertRow) {
        this.setState({ insertRow })
        this.setState({
            activerow_ind: -1
        })
        if (insertRow === 0) {
            this.props.ChangeKaf_Otdel(null, null)
            this.props.ChangeTeacher(null, null)
            this.props.ChangeDoljnost(null, null)
        }
        this.props.plusInsertRow(insertRow)
    }

    sureDelete(SureDel, t_fio_delete, id_timesheet_user) {
        this.props.sureDelete(SureDel, t_fio_delete, id_timesheet_user)
    }

    OpenSelectorOptions(options, option_name) {
        this.props.OpenSelectorOptions(options, option_name)
    }

    postTimesheetUsersUpdate = () => {
        this.props.postTimesheetUsersUpdate(
            this.props.id_kafedra_otdel,
            this.props.id_teacher,
            this.props.id_doljnost,
            this.props.id_AVN_User,
            this.state.id_timesheet_user)
        this.activeUpdateRow(0, null)
    }

    postTimesheetUsersInsert = () => {
        this.props.postTimesheetUsersInsert(
            this.props.id_kafedra_otdel,
            this.props.id_teacher,
            this.props.id_doljnost,
            this.props.id_AVN_User,
            this.props.statusS)
        this.plusInsertRow(0)
    }

    postTimesheetUsersDelete = (id_timesheet_user) => {
        this.props.postTimesheetUsersDelete(id_timesheet_user)
        this.sureDelete(null, null, null)
    }


    render() {
        const { Filtered_TeacherList } = this.state
        const { TimesheetUsers, TimesheetPosts, Kafedra_Otdel, Teacher_List } = this.props
        return (
            <div>
                <div className='Admin_container'>
                    <div className='Admin_menu'>
                        <h3 className={this.props.statusS == 0 && 'active_left'}
                            onClick={() => this.SelectStatusS(0)}>Кафедры</h3>
                        <h3 className={this.props.statusS == 1 && 'active_right'}
                            onClick={() => this.SelectStatusS(1)}>Отделы</h3>
                    </div>
                    <div className='Admin_instruments' >
                    </div>
                </div>
                <table>
                    <thead>
                        <tr>
                            <th style={{ width: '60px' }}>№</th>
                            <th style={{ width: '30%', textAlign: 'center' }}>Название</th>
                            <th style={{ width: '35%', textAlign: 'center' }}>ФИО</th>
                            <th style={{ width: '20%', textAlign: 'center' }}>Должность</th>
                            <th style={{ width: '8%' }}>Действие</th>
                        </tr>
                    </thead>
                    <tbody>
                        {TimesheetUsers && TimesheetUsers.length ? TimesheetUsers.map((item, index) => (
                            <tr key={'SpecialList' + index} className={this.props.activerow === 1 && this.props.activerow_ind === index && 'insert_row'}>
                                <td>{index + 1}</td>
                                <td style={{ textAlign: 'left', padding: '0 10px' }}>{item.kafedra_otdel}</td>
                                <td style={{ textAlign: 'left', padding: '0 10px' }}>{item.t_fio}</td>
                                <td>{item.timesheet_post}</td>
                                <td>
                                    <i className="far fa-edit" onClick={() => this.activeUpdateRow(1, index, item.id_timesheet_user)} title='Изменить'></i>
                                    <i className="far fa-trash-alt" onClick={() => this.sureDelete(1 + 'DocUser', item.t_fio, item.id_timesheet_user)} title='Удалить'></i>
                                </td>
                            </tr>)) : null}
                        <tr><td className='Plus_row' onClick={() => this.plusInsertRow(1)} title='Добавить'>+</td></tr>
                    </tbody>
                </table>
                {this.props.activerow === 1 ?
                    <div className='Redact_okno_bg'>
                        <div className='Redact_okno'>
                            <div className="selectors_container">
                                <div>
                                    <p>{this.props.statusS === 0 ? 'Кафедра:' : 'Отдел:'}</p>
                                    <div className="selector">
                                        <h2 className="select" onClick={() => this.props.options === 0 ? this.OpenSelectorOptions(1, 'kafedra_otdel') :
                                            this.OpenSelectorOptions(0, null)} >
                                            {this.props.id_kafedra_otdel > 0 ? this.props.kafedra_otdel : <b>Выберите</b>}
                                        </h2>
                                        {this.props.options === 1 && this.props.option_name === 'kafedra_otdel' ?
                                            <span>
                                                {Kafedra_Otdel && Kafedra_Otdel.length && Kafedra_Otdel.map((item, index) => {
                                                    return (
                                                        <p
                                                            style={{ color: this.props.id_kafedra_otdel === item.id_kafedra_otdel && '#7F9CF5' }}
                                                            key={index} onClick={() => this.props.ChangeKaf_Otdel(item.id_kafedra_otdel, item.kafedra_otdel)}>
                                                            {item.kafedra_otdel}
                                                        </p>
                                                    )
                                                })}
                                            </span> : null}
                                    </div>
                                </div>
                                {this.props.Teacher_List?.length > 30 ? <input
                                    className='search_teacher_Input'
                                    onChange={this.onChangeFilterFio}
                                    placeholder="Введите ФИО" /> : null}
                                {this.props.Teacher_List?.length > 30 ? <div>
                                    <p>ФИО:</p>
                                    <div className="selector">

                                        <h2 className="select" onClick={() => this.props.options === 0 ? this.OpenSelectorOptions(1, 'teacher_list') :
                                            this.OpenSelectorOptions(0, null)} >
                                            {this.props.id_teacher > 0 ? this.props.t_fio : <b>Выберите сотрудника</b>}
                                        </h2>

                                        {(this.props.options === 1 && this.props.option_name === 'teacher_list') ?
                                            <span>
                                                {Filtered_TeacherList && Filtered_TeacherList.length ? Filtered_TeacherList.map((item, index) => {
                                                    return (
                                                        <p
                                                            style={{ color: this.props.id_teacher === item.id_teacher && '#7F9CF5' }}
                                                            key={index} onClick={() => this.ChangeTeacher(item.id_teacher, item.t_fio)}>
                                                            {item.t_fio}
                                                        </p>
                                                    )
                                                }) :
                                                    Teacher_List && Teacher_List.length ? Teacher_List.map((item, index) => {
                                                        return (
                                                            <p
                                                                style={{ color: this.props.id_teacher === item.id_teacher && '#7F9CF5' }}
                                                                key={index} onClick={() => this.ChangeTeacher(item.id_teacher, item.t_fio)}>
                                                                {item.t_fio}
                                                            </p>
                                                        )
                                                    }) : null}
                                            </span> : null}
                                    </div>
                                </div> :
                                    <div>
                                        <p>ФИО:</p>
                                        <div className="selector">
                                            <h2 className="select" onClick={() => this.props.options === 0 ? this.OpenSelectorOptions(1, 'teacher_list') :
                                                this.OpenSelectorOptions(0, null)} >
                                                {this.props.id_teacher > 0 ? this.props.t_fio : <b>Выберите сотрудника</b>}
                                            </h2>
                                            {this.props.options === 1 && this.props.option_name === 'teacher_list' ?
                                                <span>
                                                    {Teacher_List && Teacher_List.length && Teacher_List.map((item, index) => {
                                                        return (
                                                            <p
                                                                style={{ color: this.props.id_teacher === item.id_teacher && '#7F9CF5' }}
                                                                key={index} onClick={() => this.props.ChangeTeacher(item.id_teacher, item.t_fio)}>
                                                                {item.t_fio}
                                                            </p>
                                                        )
                                                    })}
                                                </span> : null}
                                        </div>
                                    </div>}
                                <div>
                                    <p>Должность:</p>
                                    <div className="selector">
                                        <h2 className="select" onClick={() => this.props.options === 0 ? this.OpenSelectorOptions(1, 'doljnost') :
                                            this.OpenSelectorOptions(0, null)} >
                                            {this.props.id_doljnost > 0 ? this.props.doljnost_name : <b>Выберите должность</b>}
                                        </h2>
                                        {this.props.options === 1 && this.props.option_name === 'doljnost' ?
                                            <span>
                                                {TimesheetPosts && TimesheetPosts.length && TimesheetPosts.map((item, index) => {
                                                    return (
                                                        <p
                                                            style={{ color: this.props.id_doljnost === item.id_timesheet_post && '#7F9CF5' }}
                                                            key={index} onClick={() => this.props.ChangeDoljnost(item.id_timesheet_post, item.timesheet_post)}>
                                                            {item.timesheet_post}
                                                        </p>
                                                    )
                                                })}
                                            </span> : null}
                                    </div>
                                </div>
                                <div className='Button_container'>
                                    {this.props.activerow_ind > -1 && (this.props.id_kafedra_otdel !== TimesheetUsers[this.props.activerow_ind].id_kafedra_otdel) ||
                                        this.props.activerow_ind > -1 && (this.props.id_teacher !== TimesheetUsers[this.props.activerow_ind].id_teacher) ||
                                        this.props.activerow_ind > -1 && (this.props.id_doljnost !== TimesheetUsers[this.props.activerow_ind].id_timesheet_post) ?
                                        <label className='save_button' onClick={() => this.postTimesheetUsersUpdate()}>
                                            <i className="fas fa-save"></i>
                                            Сохранить
                                        </label> : null}
                                    <label className='cancel_button' onClick={() => this.activeUpdateRow(0, -1)}>
                                        <i className="fas fa-ban"></i>
                                        Отмена
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div> : null}

                {this.props.insertRow === 1 ?
                    <div className='Redact_okno_bg'>
                        <div className='Redact_okno'>
                            <div className="selectors_container">
                                <div>
                                    <p>{this.props.statusS === 0 ? 'Кафедра:' : 'Отдел:'}</p>
                                    <div className="selector">
                                        <h2 className="select" onClick={() => this.props.options === 0 ? this.OpenSelectorOptions(1, 'kafedra_otdel') :
                                            this.OpenSelectorOptions(0, null)} >
                                            {this.props.id_kafedra_otdel > 0 ? this.props.kafedra_otdel : <b>Выберите {this.props.statuss === 0 ? 'кафедру' : 'отдел'}</b>}
                                        </h2>
                                        {this.props.options === 1 && this.props.option_name === 'kafedra_otdel' ?
                                            <span>
                                                {Kafedra_Otdel && Kafedra_Otdel.length && Kafedra_Otdel.map((item, index) => {
                                                    return (
                                                        <p
                                                            style={{ color: this.props.id_kafedra_otdel === item.id_kafedra_otdel && '#7F9CF5' }}
                                                            key={index} onClick={() => this.props.ChangeKaf_Otdel(item.id_kafedra_otdel, item.kafedra_otdel)}>
                                                            {item.kafedra_otdel} {" "} {item.id_timesheet_user ? <i className="fas fa-check"></i> : null}
                                                        </p>
                                                    )
                                                })}
                                            </span> : null}
                                    </div>
                                </div>
                                {this.props.Teacher_List?.length > 30 ? <input
                                    className='search_teacher_Input'
                                    onChange={this.onChangeFilterFio}
                                    placeholder="Введите ФИО" /> : null}
                                {this.props.Teacher_List?.length > 30 ? <div>
                                    <p>ФИО:</p>
                                    <div className="selector">

                                        <h2 className="select" onClick={() => this.props.options === 0 ? this.OpenSelectorOptions(1, 'teacher_list') :
                                            this.OpenSelectorOptions(0, null)} >
                                            {this.props.id_teacher > 0 ? this.props.t_fio : <b>Выберите сотрудника</b>}
                                        </h2>

                                        {(this.props.options === 1 && this.props.option_name === 'teacher_list') ?
                                            <span>
                                                {Filtered_TeacherList && Filtered_TeacherList.length ? Filtered_TeacherList.map((item, index) => {
                                                    return (
                                                        <p
                                                            style={{ color: this.props.id_teacher === item.id_teacher && '#7F9CF5' }}
                                                            key={index} onClick={() => this.ChangeTeacher(item.id_teacher, item.t_fio)}>
                                                            {item.t_fio}
                                                        </p>
                                                    )
                                                }) :
                                                    Teacher_List && Teacher_List.length ? Teacher_List.map((item, index) => {
                                                        return (
                                                            <p
                                                                style={{ color: this.props.id_teacher === item.id_teacher && '#7F9CF5' }}
                                                                key={index} onClick={() => this.ChangeTeacher(item.id_teacher, item.t_fio)}>
                                                                {item.t_fio}
                                                            </p>
                                                        )
                                                    }) : null}
                                            </span> : null}
                                    </div>
                                </div> :
                                    <div>
                                        <p>ФИО:</p>
                                        <div className="selector">
                                            <h2 className="select" onClick={() => this.props.options === 0 ? this.OpenSelectorOptions(1, 'teacher_list') :
                                                this.OpenSelectorOptions(0, null)} >
                                                {this.props.id_teacher > 0 ? this.props.t_fio : <b>Выберите сотрудника</b>}
                                            </h2>
                                            {this.props.options === 1 && this.props.option_name === 'teacher_list' ?
                                                <span>
                                                    {Teacher_List && Teacher_List.length && Teacher_List.map((item, index) => {
                                                        return (
                                                            <p
                                                                style={{ color: this.props.id_teacher === item.id_teacher && '#7F9CF5' }}
                                                                key={index} onClick={() => this.props.ChangeTeacher(item.id_teacher, item.t_fio)}>
                                                                {item.t_fio}
                                                            </p>
                                                        )
                                                    })}
                                                </span> : null}
                                        </div>
                                    </div>}
                                <div>
                                    <p>Должность:</p>
                                    <div className="selector">
                                        <h2 className="select" onClick={() => this.props.options === 0 ? this.OpenSelectorOptions(1, 'doljnost') :
                                            this.OpenSelectorOptions(0, null)} >
                                            {this.props.id_doljnost > 0 ? this.props.doljnost_name : <b>Выберите должность</b>}
                                        </h2>
                                        {this.props.options === 1 && this.props.option_name === 'doljnost' ?
                                            <span>
                                                {TimesheetPosts && TimesheetPosts.length && TimesheetPosts.map((item, index) => {
                                                    return (
                                                        <p
                                                            style={{ color: this.props.id_doljnost === item.id_timesheet_post && '#7F9CF5' }}
                                                            key={index} onClick={() => this.props.ChangeDoljnost(item.id_timesheet_post, item.timesheet_post)}>
                                                            {item.timesheet_post}
                                                        </p>
                                                    )
                                                })}
                                            </span> : null}
                                    </div>
                                </div>
                                <div className='Button_container'>
                                    {this.props.id_kafedra_otdel && this.props.id_teacher && this.props.id_doljnost ?
                                        <label className='save_button' onClick={() => this.postTimesheetUsersInsert()}>
                                            <i className="fas fa-save"></i>
                                            Сохранить
                                        </label> : null}
                                    <label className='cancel_button' onClick={() => this.plusInsertRow(0)}>
                                        <i className="fas fa-ban"></i>
                                        Отмена
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div> : null}

                {
                    this.props.SureDel === 1 + 'DocUser' &&
                    <div className='Redact_okno_bg'>
                        <div className="Delet_Sure">
                            <p>
                                <span>Вы действительно хотите удалить запись:</span> <br />
                                {this.props.t_fio_delete}
                            </p>
                            <label
                                className="save_button"
                                onClick={() =>
                                    this.postTimesheetUsersDelete(this.props.id_timesheet_user)
                                }
                            >
                                <i className="fas fa-trash-alt"> </i>Удалить
                            </label>
                            <label
                                className="cancel_button"
                                onClick={() => this.sureDelete(-1)}
                            >
                                <i className="fas fa-ban"></i>Отмена
                            </label>
                        </div>
                    </div>
                }

            </div>
        )
    }
}
